import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Why Get an Enterprise App For Your <span>Organization</span></h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                       <p>According to projections for the enterprise application market after the COVID-19 pandemic, the market was assessed at $238.36 billion in 2021.</p>
                       <p>It is anticipated to witness significant growth, reaching $527.40 billion by 2030, with a compound annual growth rate (CAGR) of 8.2% from 2020 to 2030.</p>
                       <p>Well those were the stats. Let’s discuss on why you need an enterprise application for your organizarion:</p>
                    </Col>
                </Row>
                <Row className="h-100 buss-padd">
                <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Enhanced Efficiency</h6>
                            <p>Enterprise apps streamline processes, reducing manual efforts and enhancing overall efficiency within your organization.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Improved Productivity</h6>
                            <p>With easy access to tools and information, employees can boost their productivity, accomplishing tasks more efficiently.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Scalability</h6>
                            <p>Enterprise apps can scale to accommodate increased demands and changing business requirements.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Real-time Analytics</h6>
                            <p>Gain insights into your business operations with real-time analytics provided by enterprise apps, allowing for informed decision-making.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Data Security</h6>
                            <p>Enterprise apps often come with robust security features, ensuring the confidentiality and integrity of your organization's data.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Androidbuss